import verified from "@/assets/verified.svg";
import { getAuth } from "firebase/auth";
import { useIsLocationAllowed } from "@/hooks/useIsLocationAllowed";


export function Profile() {
  const auth = getAuth();
  const [location] = useIsLocationAllowed();

  return (
    <div className="flex items-center py-4 max-w-xs">
      <div className="flex items-center space-x-3">
        <div className="bg-blue-dark w-12 h-12 rounded-md flex items-center justify-center text-white font-bold text-xl">
          {auth?.currentUser?.displayName ?<span className="text-white text-2xl opacity-80">
            {auth?.currentUser?.displayName.substring(0,1)}
          </span> : null}
        </div>
        <div className="flex flex-col">
          <div className="flex items-center">
            <span className="font-normal text-lg text-blue-dark font-semibold">
              {auth?.currentUser?.displayName ?<span>{auth?.currentUser?.displayName}</span> : null}
            </span>
            <span className="ml-1 mt-[1px]">
                <img src={verified} alt="Verified" className="h-4 w-4" />
            </span>
          </div>
          <span className="text-slate text-sm opacity-80">
            Verified in {location?.locationName}
          </span>
        </div>
      </div>
    </div>
  );
};